<template>
  <van-row class="home_banner">
    <van-col span="8" v-if="noticeCard1.display" style="padding-right: 10px;">
      <img :src="noticeCard1.url" alt="" @click="goToPath(noticeCard1.redirectUrl)">
    </van-col>
    <van-col span="8" v-if="noticeCard2.display" style="padding-right: 10px;">
      <img :src="noticeCard2.url" alt="" @click="goToPath(noticeCard2.redirectUrl)">
    </van-col>
    <van-col span="8" v-if="noticeCard3.display">
      <img :src="noticeCard3.url" alt="" @click="goToPath(noticeCard3.redirectUrl)">
    </van-col>
    <van-col span="24" v-if="noticeCard4.display">
      <img :src="noticeCard4.url" alt="" @click="goToPath(noticeCard4.redirectUrl)">
    </van-col>
  </van-row>
</template>

<script setup lang="ts">
import { BannerItem, useNavigation } from '@/view/home/supportScript';
import { defineProps, onMounted, ref } from 'vue'

const { goToPath } = useNavigation()

const noticeCard1 = ref({
  url: '',
  redirectUrl: '',
  display: false
})
const noticeCard2 = ref({
  url: '',
  redirectUrl: '',
  display: false
})
const noticeCard3 = ref({
  url: '',
  redirectUrl: '',
  display: false
})
const noticeCard4 = ref({
  url: '',
  redirectUrl: '',
  display: false
})
const props = defineProps<{
  itemData: {
    notice1: BannerItem,
    notice2: BannerItem,
    notice3: BannerItem,
    notice4: BannerItem
  }
}>()

onMounted(() => {
  noticeCard1.value.url = props.itemData?.notice1.url
  noticeCard1.value.redirectUrl = props.itemData?.notice1.redirectUrl
  noticeCard1.value.display = props.itemData?.notice1.display

  noticeCard2.value.url = props.itemData?.notice2.url
  noticeCard2.value.redirectUrl = props.itemData?.notice2.redirectUrl
  noticeCard2.value.display = props.itemData?.notice2.display

  noticeCard3.value.url = props.itemData?.notice3.url
  noticeCard3.value.redirectUrl = props.itemData?.notice3.redirectUrl
  noticeCard3.value.display = props.itemData?.notice3.display

  noticeCard4.value.url = props.itemData?.notice4.url
  noticeCard4.value.redirectUrl = props.itemData?.notice4.redirectUrl
  noticeCard4.value.display = props.itemData?.notice4.display


})
</script>
<style scoped>
.home_banner img {
  width: 100%;
  border-radius: 9px;
  padding: 5px 0 2px 0px;
}
</style>